import { render, staticRenderFns } from "./LoansTabs.vue?vue&type=template&id=d8772c9e&scoped=true&"
import script from "./LoansTabs.vue?vue&type=script&lang=ts&"
export * from "./LoansTabs.vue?vue&type=script&lang=ts&"
import style0 from "./LoansTabs.vue?vue&type=style&index=0&id=d8772c9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8772c9e",
  null
  
)

export default component.exports